import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "Undefined"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M8.24995 10.5H15.75V13.5H8.24995V10.5ZM10.8952 22.0425C11.1879 22.3359 11.5855 22.5006 12 22.5C12.4143 22.5008 12.8119 22.3364 13.1047 22.0432L22.0432 13.1047C22.6522 12.4941 22.6522 11.5058 22.0432 10.8952L13.1047 1.95671C12.4941 1.34776 11.5058 1.34776 10.8952 1.95671L1.95671 10.896C1.34776 11.5066 1.34776 12.4948 1.95671 13.1055L10.8952 22.0425ZM11.9549 3.01795C11.9669 3.00619 11.9831 2.99971 11.9999 2.99995V2.9992C12.0168 2.99916 12.033 3.00591 12.0449 3.01795L20.9819 11.9564C21.0061 11.981 21.0061 12.0204 20.9819 12.0449L12.0434 20.9819C12.0189 21.0062 11.9794 21.0062 11.9549 20.9819L3.01866 12.0434C2.99445 12.0189 2.99445 11.9795 3.01866 11.9549L11.9549 3.01795Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/Undefined.vue"]]);
